"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgShPhoneAltSolid(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 13.182 15.212"
    }, props),
    React.createElement("path", { d: "M12.806 10.75L9.922 9.324a.566.566 0 00-.721.205l-1.277 1.8a10.4 10.4 0 01-4.562-5.264l1.561-1.471a.785.785 0 00.177-.835L3.865.431a.605.605 0 00-.708-.413L.479.731A.7.7 0 000 1.426c0 7.622 5.353 13.787 11.946 13.787a.644.644 0 00.6-.553l.618-3.09a.754.754 0 00-.361-.82z" })
  );
}

exports.default = SvgShPhoneAltSolid;
module.exports = exports["default"];